module.exports = __webpack_public_path__ + "img/39.c5818f90.png";